import { RecipeVariantProps, sva } from "styled-system/css";

export const eventWidgetCardRecipe = sva({
  slots: ["surface", "body", "dateAndTitle", "hero"],
  base: {
    surface: {
      display: "grid",
      flexGrow: 1,
      flexShrink: 0,
      backgroundColor: "#FFF",
      borderRadius: "12px",
      cursor: "pointer",
      _hover: {
        borderColor: "border.mid",
      },
      _focusVisible: {
        outlineOffset: "-1px",
        outlineWidth: "1px",
        outlineStyle: "solid",
        outlineColor: "border.mid",
      },
    },
    body: {
      p: "24px",
      justifyContent: "space-between",
      rowGap: "0",
      w: "full",
      gridArea: "cardBody",
    },
    dateAndTitle: {
      flexDir: "column",
      gap: "100",
    },
    hero: {
      display: "flex",
      alignItems: "center",
      // Super weird. In theory, there should be a gridArea here called cardHero,
      // but when it is added it breaks the grid in landscape mode. No idea why.
    },
  },
  variants: {
    orientation: {
      landscape: {
        surface: {
          gridTemplateAreas: "'cardBody' 'cardHero'",
          gridTemplateColumns: "auto 160px",
          minW: "360px",
          h: "160px",
          maxH: "160px",
          minH: "160px",
        },
        hero: {
          w: "160px",
          maxW: "160px",
          minW: "160px",
          h: "160px",
          maxH: "160px",
          minH: "160px",
        },
      },
      portrait: {
        surface: {
          gridTemplateAreas: "'cardHero' 'cardBody'",
          gridTemplateRows: "200px 160px",
          w: "280px",
          maxW: "280px",
          h: "360px",
          maxH: "360px",
        },
        hero: {
          w: "280px",
          maxW: "280px",
          minW: "280px",
          h: "200px",
          maxH: "200px",
          minH: "200px",
        },
      },
    },
  },
  defaultVariants: {
    orientation: "portrait",
  },
});

export type EventWidgetCardRecipeProps = RecipeVariantProps<
  typeof eventWidgetCardRecipe
>;
